import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'MegaPack Psicología: Carrera Resuelta — Sistema Completo para Estudiantes de Psicología en Argentina';
// Preconnect ONLY to the critical origin (Cloudinary hosts the LCP image + all product images)
const cloudinary = 'https://res.cloudinary.com';
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = cloudinary;
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
const dns = document.createElement('link');
dns.rel = 'dns-prefetch';
dns.href = cloudinary;
document.head.appendChild(dns);
// Preload hero image (LCP) — uses imagesrcset/imagesizes so the browser picks the right variant
const HERO_BASE = 'https://res.cloudinary.com/dowzlbqlz/image/upload';
const HERO_PATH = '/v1779299791/hf_20260520_174347_12932f9a-1a74-4f23-8277-79ff39ba8c41-Photoroom_b2kvbb.webp';
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = `${HERO_BASE}/f_auto,q_auto,w_400${HERO_PATH}`;
preloadImg.setAttribute('imagesrcset', `${HERO_BASE}/f_auto,q_auto,w_320${HERO_PATH} 320w, ${HERO_BASE}/f_auto,q_auto,w_400${HERO_PATH} 400w, ${HERO_BASE}/f_auto,q_auto,w_600${HERO_PATH} 600w, ${HERO_BASE}/f_auto,q_auto,w_760${HERO_PATH} 760w`);
preloadImg.setAttribute('imagesizes', '(min-width: 640px) 380px, 320px');
preloadImg.setAttribute('fetchpriority', 'high');
document.head.appendChild(preloadImg);
render(<App data-id="element-412" />, document.getElementById('root'));